"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Styling_1 = require("../../Styling");
exports.getStyles = Utilities_1.memoizeFunction(function (customStyles) {
    var styles = {
        host: {}
    };
    return Styling_1.mergeStyleSets(styles, customStyles);
});
//# sourceMappingURL=HoverCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/HoverCard/HoverCard.styles.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/HoverCard/HoverCard.styles.js
// module chunks = 1